import { render, staticRenderFns } from "./yinsi.vue?vue&type=template&id=2f3de1c3&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./yinsi.vue?vue&type=script&lang=js"
export * from "./yinsi.vue?vue&type=script&lang=js"
import style0 from "./yinsi.vue?vue&type=style&index=0&id=2f3de1c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3de1c3",
  null
  
)

export default component.exports